import aghapi from '../../api/aghapi.js'
const ORDER_DETAIL='ORDER_DETAIL'
const ORDER_TRACK='ORDER_TRACK'


const state = {
    orderDetail:{},
    orderTrack:{}
}

// getters
const getters = {
   getorderDetail:state=>{return state.orderDetail},
   getorderTrack:state=>{return state.orderTrack}
}

// actions
const actions = {
    loadOrderDetail({commit},params){
        aghapi.getOrderDetail(params).then((res)=>{
            if(res.data&&res.data.errno==0){
                commit(ORDER_DETAIL,{data:res.data.body})
            }
        })
    },
    loadOrderTrack({commit},params){
    	aghapi.getOrderTrack(params).then((res)=>{
    		if(res.data&&res.data.errno==0){
    			commit(ORDER_TRACK,{data:res.data.body})
    		}
    	})
    },


}

// mutations
const mutations = {
    [ORDER_DETAIL](state, { data }) {
        state.orderDetail = data
    },
    [ORDER_TRACK](state, { data }) {
        state.orderTrack = data
    },

}

export default {
    state,
    getters,
    actions,
    mutations
}